import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { baseUrl } from "../../../../boot";

// Get products
export const getProduct = createAsyncThunk("/get-inventory", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}inventory/api/v1/get-inventory`, data, {
      headers: {
        "auth-token": token,
        // "Content-Type": "application/json",
      },
    });
    console.log("product response", response);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});
export const getProduct_Mechanism = createAsyncThunk("/get-rawMaterial-mechanism", async (data, { rejectWithValue }) => {
  const token = localStorage.getItem("authToken");

  try {
    const response = await axios.post(`${baseUrl}rawMaterial/api/v1/get-RawMaterial-Products`, data, {
      headers: {
        // "auth-token": token,
        "Content-Type": "application/json",
      },
    });
    console.log("raw material mechanism response", response);
    return response.data; // ✅ Return only the data
  } catch (error) {
    console.error("Error fetching products:", error);

    // ✅ Handle errors properly
    return rejectWithValue(error.response?.data?.message || "Failed to fetch products");
  }
});

export const getProductById = createAsyncThunk(
  "inventory/getById",
  async (productId, { rejectWithValue }) => {
    const token = localStorage.getItem("authToken");

    try {
      const response = await axios.get(
        `${baseUrl}inventory/api/v1/get-inventory-by-id/${productId}`,
        {
          headers: {
            "auth-token": token,
          },
        }
      );

      return response.data;
    } catch (error) {
      console.error("Error fetching product by ID:", error);
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch product"
      );
    }
  }
);

